import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import _ from 'lodash';
import {
  setCart,
  setrotationCart,
} from '../create-order/cement/cement-state/cement.action';
import { UtilsService } from 'src/app/shared/services/utils.service';
import { CreateOrderService } from '../create-order/cement/Services/create-order.service';
import moment from 'moment';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class ClickItService {
  localData: any;
  self: any;
  itemDataState: any;
  business: any;
  allCartData: any;
  creditBalanceCheck: any;
  userData: any;
  isSouthAfricaCheck: any;
  creditBlockCheck: any;
  hitPriceSimulation: any;
  links: any;
  updateBalance: any = 0;
  totalAmount: any = 0;
  reOrderValue: any;
  refresh: boolean = false;
  digitalOrderSystem: any;
  SettingsData: any;
  disableBalChecking: any;
  loader: boolean = false;
  isAggregate: boolean = false;
  isAsphalt: boolean = false;
  EXCEL_TYPE =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  EXCEL_EXTENSION = '.xlsx';

  deliverpdfUrl: any;
  private showBalanceError = new BehaviorSubject<boolean>(false);
  private sapBlockedCheck = new BehaviorSubject<boolean>(false);
  balaceError$ = this.showBalanceError.asObservable();
  sapBlockedCheckError$ = this.sapBlockedCheck.asObservable();
  setBalanceError(status: boolean): void {
    console.log(status);

    this.showBalanceError.next(status);
  }
  setCheckSapOrder(status:boolean){
    this.sapBlockedCheck.next(status);
  }
  userId = '';
  email = '';
  username = '';

  constructor(
    private http: HttpClient,
    private store: Store<any>,
    private util: UtilsService,
    private createService: CreateOrderService,
    private router: Router
  ) {
    this.store
      .select((state) => state)
      .subscribe((data) => {
        this.userId = data?.authReducer?.userDetails?.id ?? '';
        this.email = data?.authReducer?.userDetails?.email ?? '';
        this.username = data?.authReducer?.userDetails?.first_name ?? '';
        this.localData = data.authReducer;
        this.self = data.authReducer?.allApiLinks?.self?.href;
        this.business = data.authReducer?.businessDetails;
        this.allCartData = data.cartReducer?.cartData;
        this.isSouthAfricaCheck = this.business?.locale == 'en-Za';
        this.userData = data.authReducer.userDetails;
        this.deliverpdfUrl =
          data.authReducer.businessDetails?.settings_data?.DIGITAL_ORDERING_DOMAIN;

        this.creditBlockCheck = this.userData?.settings_data?.hasOwnProperty(
          'CHECK_CREDIT_BLOCKED'
        )
          ? this.userData?.settings_data?.CHECK_CREDIT_BLOCKED
          : false;

        this.hitPriceSimulation =
          this.userData?.settings_data?.ENABLE_PRICE_SIMULATION || false;
        this.links = data.authReducer.allApiLinks;
        this.digitalOrderSystem =
          this.userData?.settings_data?.DIGITAL_ORDER_SYSTEM;
        this.SettingsData = data.authReducer?.businessDetails?.settings_data;
        this.disableBalChecking =
          this.SettingsData?.DISABLE_BALANCE_CHEKING || false;
      });
  }

  private quantityError = new BehaviorSubject(false);
  callQuantityError = this.quantityError.asObservable();

  setQuantityErrorData(data) {
    this.quantityError.next(data);
  }

  private priceApiError = new BehaviorSubject(false);
  callPriceApiError = this.priceApiError.asObservable();
  setPriceApiError(data) {
    this.priceApiError.next(data);
  }
  roles = [
    {
      role: 'Owner',
    },
    {
      role: 'Sales Person',
    },
    {
      role: 'Store Manager',
    },
    {
      role: 'View Only',
    },
  ];

  getNotification(data: any) {
    return this.http.get(
      `${this.localData?.allApiLinks?.self?.href}/businesses/${this.localData?.userDetails?.business?.id}/in_app_notifications?range=[${data.startIndex},${data.endIndex}]`
    );
  }

  viewProfile(id: any) {
    return this.http.post<any>(
      `${this.localData?.loginDetails?.url}/businesses/selector`,
      id
    );
  }

  fetchUserDetails() {
    return this.http.get<any>(
      `${this.localData?.loginDetails?.url}/businesses/users/${this.localData?.otpVerifiedDetails?.id}`
    );
  }

  notificationMarkAsRead(data: any) {
    const payload = {
      data: data,
    };
    return this.http.post(
      `${this.localData?.allApiLinks?.self?.href}/businesses/${this.localData?.userDetails?.business?.id}/in_app_notifications/mark_as_read`,
      payload
    );
  }

  storeToken(data: any) {
    return this.http.post(
      `${this.localData?.allApiLinks?.push_subscriptions?.href}`,
      data
    );
  }

  editProfile(data: any) {
    let formData = new FormData();
    formData.append('first_name', data?.first_name);
    formData.append('last_name', data?.last_name);
    formData.append('phone', data?.phone);
    formData.append('country_code', data?.country_code);
    formData.append('email', data?.email);
    formData.append('address', data?.address);
    formData.append('role_id', data?.role_id);
    formData.append('remove_logo', data?.remove_logo);
    formData.append('profile_image', data?.profile_image);
    return this.http.patch<any>(
      `${this.localData?.allApiLinks?.self?.href}/businesses/${this.localData?.userDetails?.business?.id}/users/${this.localData?.otpVerifiedDetails?.id}`,
      formData
    );
  }

  editUser(data: any) {
    let ship_to_list: any;
    let payer_list: any;
    let contract_list: any;
    if (typeof data.ship_to_list === 'object') {
      ship_to_list = JSON.stringify(data['ship_to_list']);
    } else {
      ship_to_list = [];
    }
    if (typeof data.contract_list === 'object') {
      contract_list = JSON.stringify(data['contract_list']);
    } else {
      contract_list = [];
    }
    if (typeof data.payer_list === 'object') {
      payer_list = JSON.stringify(data['payer_list']);
    } else {
      payer_list = [];
    }
    let formData = new FormData();
    formData.append('first_name', data?.first_name);
    formData.append('last_name', data?.last_name);
    formData.append('email', data?.email);
    formData.append('phone', data?.phone);
    formData.append('country_code', data?.country_code);
    formData.append('address', data?.address ? data?.address : '');
    formData.append('role_id', data?.role_id);
    formData.append('remove_logo', 'false');
    formData.append('profile_image', data?.profile_image);
    formData.append('ship_to_list', ship_to_list);
    formData.append('contract_list', contract_list);
    formData.append('payer_list', payer_list);
    return this.http.patch<any>(
      `${this.localData?.allApiLinks?.self?.href}/businesses/${this.localData?.userDetails?.business?.id}/users/${this.localData?.selectedUser?.id}`,
      formData
    );
  }
  getUsersList() {
    return this.http.get<any>(
      `${this.localData?.allApiLinks?.self?.href}/businesses/${this.localData?.userDetails?.business?.id}/users`
    );
  }

  getSiteList() {
    return this.http.post<any>(
      `${this.localData?.allApiLinks?.self?.href}/businesses/${this.localData?.userDetails?.business?.id}/user_ship_to_list_mapping`,
      {}
    );
  }

  getContractList() {
    return this.http.get<any>(
      `${this.localData?.allApiLinks?.self?.href}/businesses/${this.localData?.userDetails?.business?.id}/get_contracts_list`,
      {}
    );
  }

  addUser(data: any) {
    console.log(typeof data.ship_to_list);
    let ship_to_list: any;
    let payer_list: any;
    let contract_list: any;
    if (typeof data.ship_to_list === 'object') {
      ship_to_list = JSON.stringify(data['ship_to_list']);
    } else {
      ship_to_list = [];
    }
    if (typeof data.payer_list === 'object') {
      payer_list = JSON.stringify(data['payer_list']);
    } else {
      payer_list = [];
    }

    if (typeof data.contract_list === 'object') {
      contract_list = JSON.stringify(data['contract_list']);
    } else {
      contract_list = [];
    }
    let formData = new FormData();
    formData.append('first_name', data?.first_name);
    formData.append('last_name', data?.last_name);
    formData.append('phone', data?.phone);
    formData.append('country_code', data?.country_code);
    formData.append('email', data?.email);
    formData.append('address', data?.address);
    formData.append('role_id', data?.role_id);
    formData.append('ship_to_list', ship_to_list);
    formData.append('contract_list', contract_list);
    formData.append('payer_list', payer_list);
    formData.append('profile_image', data?.profile_image);
    formData.append('phone_code', data?.code);
    return this.http.post<any>(
      `${this.localData?.allApiLinks?.self?.href}/businesses/${this.localData?.userDetails?.business?.id}/users`,
      formData
    );
  }

  deleteUser() {
    return this.http.delete<any>(
      `${this.localData?.allApiLinks?.self?.href}/businesses/${this.localData?.userDetails?.business?.id}/users/${this.localData.selectedUser.id}`
    );
  }

  getRoles() {
    return this.http.get<any>(
      `${this.localData?.allApiLinks?.self?.href}/businesses/roles`
    );
  }

  FIND_INCOTERM_TYPE(incoterm, isMdd) {
    if (incoterm === 'DDP') {
      if (isMdd) {
        return 'MDD';
      }
      return 'delivered';
    } else if (incoterm === 'FCA') {
      return 'agency';
    } else if (incoterm === 'MDD') {
      return 'MDD';
    } else if (incoterm === 'DAP') {
      return 'DAP';
    }
    return 'self_collect';
  }

  PRINT_MODE(incoterm) {
    if (incoterm === 'DDP') {
      return 'Delivery';
    } else if (incoterm == 'EXW') {
      return 'Pickup';
    } else if (incoterm == 'FCA') {
      return 'FCA';
    } else if (incoterm == 'MDD') {
      return 'MDD';
    } else if (incoterm == 'DAP') {
      return 'DAP';
    }

    return '';
  }

  FIND_REVERSE_INCOTERM_TYPE(type) {
    if (type === 'delivered' || type === 'MDD') {
      return 'DDP';
    } else if (type === 'agency') {
      return 'FCA';
    }
    return 'EXW';
  }

  deActivateUser() {
    return this.http.put<any>(
      `${this.localData?.allApiLinks?.self?.href}/businesses/${this.localData?.userDetails?.business?.id}/users/${this.localData.selectedUser.id}/change_status`,
      {}
    );
  }

  fetchSelectedUserDetails(userid: any) {
    return this.http.get<any>(
      `${this.localData?.loginDetails?.url}/businesses/users/${this.localData?.otpVerifiedDetails?.id}/user_list/${userid}`
    );
  }

  statusColorCheck(customer_order_status: any) {
    switch (customer_order_status) {
      case '0':
        return { color: '#2F3247' };
      case 'D':
        return { color: '#2F3247' };
      case '4':
        return { color: '#808080' };
      default:
        return { color: '#ffffff' };
    }
  }
  statusBackColorCheck(customer_order_status: any) {
    switch (customer_order_status) {
      case '0':
        return { backgroundColor: '#D0DFEB' };
      case '1':
        return { backgroundColor: '#53A5EC' };
      case 'A':
        return { backgroundColor: '#53A5EC' };
      case '2':
        return { backgroundColor: '#DBA81F' };
      case 'B':
        return { backgroundColor: '#DBA81F' };
      case '3':
        return { backgroundColor: '#46B146' };
      case 'C':
        return { backgroundColor: '#46B146' };
      case '4':
        return { backgroundColor: '#E0E0E0' };
      case 'D':
        return { backgroundColor: '#D0DFEB' };
      case '5':
        return { backgroundColor: '#46B146' };
      default:
        return { backgroundColor: '#46B146' };
    }
  }

  //updated processOrder start

  processOrder(comp: any, orderData: any, index: any) {
    this.loader = true;
    console.log(orderData);
    this.itemDataState = orderData?.orderDetails || orderData;
    this.store.dispatch(
      setCart({
        data: {
          ...this.allCartData,
          scheduleOrderData: [],
          showScheduleOrder: false,
          discount_Details: {},
          couponValue: false,
          reorder: true
        },
      })
    );
    const blockUrl = `${this.self}businesses/${this.localData?.userDetails?.business?.id}/is_sap_blocked`;
    const isTrackOrder = comp === 'trackOrder';

    this.http.get(blockUrl).subscribe({
      next: (res: any) => {
        if (!res?.is_sap_blocked) {
          if (isTrackOrder) {
            console.log("if");

            const url = `${this.self}businesses/${this.localData?.userDetails?.business?.id}/latest_orders/${this.itemDataState?.id}`;
            this.getAndUpdateItemDataState(url);
          } else if (comp === 'dashboard') {
            this.updateItemDataState(orderData);
          } else {
            this.updateItemDataState(this.itemDataState);
          }
        }else{
            this.loader = false;
            this.setCheckSapOrder(true);
        }
      },
    });

    this.reOrderValue = 'reOrder';
    localStorage.setItem('orderValue', this.reOrderValue);
  }

  getAndUpdateItemDataState(url: string) {
    console.log(url, 'url');

    this.http.get(url).subscribe({
      next: (res: any) => {
        let showQuantityError = false;
        if (this.userData?.settings_data?.SHOW_REMAINING_QTY) {
          res?.reorder_line_items.forEach((val) => {
            if (val?.order_quantity > val?.quantity?.available) {
              showQuantityError = true;
            }
          });
        }
        if (
          this.userData?.settings_data?.SHOW_REMAINING_QTY &&
          showQuantityError
        ) {
          this.setQuantityErrorData(true);
          this.loader = false;
        } else {
          this.itemDataState = res;
          this.callMethodsWithData(this.itemDataState);
        }
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  updateItemDataState(data: any) {
    console.log(data);
    let showQuantityError = false;
    if (this.userData?.settings_data?.SHOW_REMAINING_QTY) {
      data?.reorder_line_items.forEach((val) => {
        if (val?.order_quantity > val?.quantity?.available) {
          showQuantityError = true;
        }
        if (val?.products_master?.product_category == 'aggregate') {
          this.isAggregate = true;
          this.isAsphalt = false;
        } else if (val?.products_master?.product_category == 'asphalt') {
          this.isAsphalt = true;
          this.isAggregate = false;
        } else {
          this.isAggregate = false;
          this.isAsphalt = false;
        }
      });
    }
    if (this.userData?.settings_data?.SHOW_REMAINING_QTY && showQuantityError) {
      this.setQuantityErrorData(true);
      this.loader = false;
    } else {
      this.creditBalanceCheck =
        this.allCartData?.balanceObject?.balance_extra_info?.find(
          (val) => val.credit_control_area === data?.credit_control_area
        )?.disable_balance_checking;
      this.callMethodsWithData(data);
    }
  }

  //processOrder code ends

  fetchPriceSimulation(resultData: any) {
    const data = {
      sap_contract: {
        id: resultData.sap_contract_id,
        contract_number: resultData.contract_number,
      },
      payer: {
        id: resultData?.business_payer.id,
        sap_code: resultData?.business_payer.payer_sap_code,
      },
      ship_to: {
        id: resultData.sap_business_site?.id,
        sap_code: resultData.sap_business_site?.ship_to_sap_number,
      },
      plant: {
        id: resultData?.sap_plant?.id,
        code: resultData?.sap_plant?.plant_code,
      },
      items: resultData.reorder_line_items.map((val: any) => {
        return {
          sap_contract_product_id: val.id,
          material_code: val.material_code,
          uom: val.products_master.input_uom,
          quantity: val.order_quantity,
          plant_code: val?.plant_code,
        };
      }),
      dispatch_date: moment(new Date()).locale('en').format(),
    };

    const simulationPath = this.links?.price_simulation_url?.href;

    const promise = new Promise((resolve, reject) => {
      let creditBalance =
        this.creditBlockCheck &&
          this.allCartData?.balanceObject?.hasOwnProperty('balance_extra_info')
          ? this.allCartData?.balanceObject?.balance_extra_info.find(
            (val: any) =>
              val.credit_control_area == resultData?.credit_control_area
          )?.sap_digital_order_balance
          : resultData?.business_payer?.sap_digital_order_balance;

      this.http.post(simulationPath, data).subscribe({
        next: (res: any) => {
          if (res.status) {
            let updatedBalance;
            updatedBalance = creditBalance
              ? creditBalance - res.data.total
              : 0 - res.data.total;

            const priceSimId = res.data?.id;
            const amount = res.data.total;
            const isConditionTrue = true;
            if (isConditionTrue) {
              this.updateBalance = updatedBalance;
              this.totalAmount = res.data.total;
            }
            this.refresh = false;
            resolve({
              amount,
              updatedBalance,
              prodArray: res.data.items,
              priceSimId,
            });
          } else if (!res.status) {
            this.refresh = false;
            console.log('no res');
            this.loader = false;
            this.setPriceApiError(true)
            reject(new Error('Api Error'));
          }
        },
        error: (err: any) => {
          this.refresh = false;
          console.log('api err==>', err);
          reject(new Error('Something Went wrong'));
        },
      });
    });

    return promise;
  }

  findProdPrice(prod: any, total: any, quantity: any) {
    const unitPriceUom = prod.unit_price_uom;
    const amount = this.hitPriceSimulation
      ? total / quantity
      : total * quantity;
    const conversionUom = prod.products_master.conversion_uom;
    const conversionFactor = prod.products_master.conversion_factor || 1;
    const priceUom = prod.products_master.show_price_in_uom;
    let unitPrice = 0;
    const prodPrice = amount || prod.price_after_tax;
    if (priceUom) {
      if (priceUom === conversionUom) {
        unitPrice = prodPrice / conversionFactor;
      } else {
        unitPrice = prodPrice;
      }
    } else if (unitPriceUom === conversionUom) {
      unitPrice = prodPrice;
    } else {
      unitPrice = prodPrice / conversionFactor;
    }

    unitPrice =
      this.digitalOrderSystem === 'isSage' ? Math.round(unitPrice) : unitPrice;
    return unitPrice;
  }

  // callMethodsWithData starts here
  callMethodsWithData(resultData: any) {
    console.log('12345 Raja')
    console.log('payer', resultData);

    let finalTotal = 0;

    const resultDataTemp = _.cloneDeep(resultData);

    const isAggregate =
      resultData?.reorder_line_items[0]?.products_master?.product_category ==
      'aggregate';
    this.isAggregate = resultData?.reorder_line_items[0]?.products_master?.product_category ==
      'aggregate' ? true : false;
    this.isAsphalt = resultData?.reorder_line_items[0]?.products_master?.product_category ==
      'asphalt' ? true : false;

    if (this.isSouthAfricaCheck) {
      resultData.reorder_line_items = resultData.reorder_line_items.filter(
        (val: any) => val.material_code != '000000000070004230'
      );
    }
    this.storeCartData(resultData);
    let canPlaceOrder = true;

    if (this.creditBlockCheck) {
      canPlaceOrder = this.allCartData.balanceObject.hasOwnProperty(
        'balance_extra_info'
      )
        ? this.allCartData?.balanceObject?.balance_extra_info &&
        !this.allCartData.balanceObject.balance_extra_info?.find(
          (val) => val.credit_control_area == resultData.credit_control_area
        ).blocked_for_credit
        : true;
    }

    if (canPlaceOrder) {
      if (this.hitPriceSimulation && resultData.contract_type == 'ZCP') {
        this.handlePriceSimulation(resultData, resultDataTemp, isAggregate);
      } else {
        this.handleNonPriceSimulation(
          resultData,
          isAggregate,
          finalTotal,
          resultDataTemp
        );
      }
    }
  }

  handlePriceSimulation(resultData, resultDataTemp, isAggregate) {
    this.fetchPriceSimulation(resultDataTemp)
      .then((res: any) => {
        console.log('res', res);

        let pickupQPList: any = [];

        if (
          resultDataTemp.reorder_line_items.findIndex(
            (val: any) => val.material_code == '000000000070004230'
          ) >= 0
        ) {
          resultDataTemp.reorder_line_items.find(
            (val: any) => val.material_code == '000000000070004230'
          ).material_number = '000000000070004230';

          resultDataTemp.reorder_line_items.find(
            (val: any) => val.material_code == '000000000070004230'
          ).unit_price =
            res.prodArray.find(
              (val: any) => val.material_number == '000000000070004230'
            ).total /
            res.prodArray.find(
              (val: any) => val.material_number == '000000000070004230'
            ).quantity;
        }
        const products = this.updateProduct(
          resultData,
          res,
          resultDataTemp,
          pickupQPList
        );
        console.log(products, 'productsproducts', this.SettingsData.IS_PAYMENT_AVAILABLE,
          res.updatedBalance > 0,
          this.disableBalChecking,
          this.creditBalanceCheck,
          !this.business?.is_price_check);

        if (
          this.SettingsData?.IS_PAYMENT_AVAILABLE ||
          res.updatedBalance > 0 ||
          this.disableBalChecking ||
          this.creditBalanceCheck ||
          !this.business?.is_price_check
        ) {
          this.addProductHandler(
            '',
            products,
            res.updatedBalance,
            res.amount,
            resultData,
            resultDataTemp,
            isAggregate
          );
        } else {
          this.refresh = false;
          this.loader = false;
          this.setBalanceError(true)
          console.log("error");

        }
      })
      .catch((err) => {
        this.refresh = false;
        console.log(err);
      });
  }

  updateProduct(resultData, res, resultDataTemp, pickupQPList) {
    return resultData.reorder_line_items.map((val: any, index: any) => {
      console.log(val);

      val['net_price'] =
        res?.prodArray[index].total_net / res?.prodArray[index].quantity;

      const conversionValue = val.products_master.show_conversion
        ? val?.order_quantity * val.products_master.conversion_factor
        : val?.order_quantity;
      const unitPrice = this.findProdPrice(
        val,
        res?.prodArray[index].total,
        val?.order_quantity
      );

      if (this.allCartData.inco_term == 'EXW') {
        for (let i = 0; i < val?.order_quantity / 40 && i < 20; i++) {
          pickupQPList.push(`${40 * (i + 1)}`);
        }
      }

      let product = {
        product: { ...val },
        conversionValue: conversionValue,
        inputValue: val?.order_quantity,
        key: val.products_master.id,
        lessCWT: val.less_cwt,
        noOfTrucks: val.no_of_trucks,
        price: unitPrice,
        product_master_id: val.products_master.id,
        total: unitPrice,
        totalPrice: res?.prodArray[index]?.total * res?.prodArray[index]?.quantity,
        truckSize: val.truckSize,
        unit: val.products_master.input_uom,
        unitPrice: unitPrice,
        palletQuantity:
          this.isSouthAfricaCheck &&
          val.material_code != '000000000070002480' &&
          val?.order_quantity / 40,
        qpDelivery: val?.order_quantity,
        palletAmount:
          this.isSouthAfricaCheck &&
            val.material_code != '000000000070002480' &&
            resultDataTemp.reorder_line_items.findIndex(
              (val) => val.material_code == '000000000070004230'
            ) >= 0
            ? (res.prodArray.find(
              (val) => val.material_number == '000000000070004230'
            ).total /
              res.prodArray.find(
                (val) => val.material_number == '000000000070004230'
              ).quantity) *
            (val?.order_quantity / 40)
            : 0,
        qpDeliveryList:
          this.allCartData.inco_term == 'DDP'
            ? [(val?.order_quantity % 800).toString()]
            : pickupQPList,
        priceSimId: res?.priceSimId,
      };

      product.product.contract_number = resultData.contract_number;
      product.product.material_number = val?.material_code;
      product.inputValue = val?.order_quantity;
      product.noOfTrucks = val?.no_of_trucks;
      product.truckSize = val?.truck_size;
      product.product.id = val?.sap_contract_product_id;

      if (resultData.mode_of_delivery == 'rotation') {
        let updatedProduct = {
          ...product,
          start_time: val?.start_time,
          end_time: val?.end_time,
          quantity: val?.quantity,
          number_of_trips: val?.number_of_trips,
          is_preload: val?.is_preload,
          truck_or_trips: val?.truck_or_trips,
          duration: val?.duration,
          comment: val?.comment,
          trucktype: val?.truck_type,
          product_master_id: val?.products_master?.id,
        };
        return updatedProduct;
      } else {
        return product;
      }
    });
  }

  handleNonPriceSimulation(
    resultData,
    isAggregate,
    finalTotal,
    resultDataTemp
  ) {
    let subtotal = 0
    const products = resultData.reorder_line_items.map(
      (val: any, index: any) => {
        console.log(val);

        const conversionValue = val.products_master.show_conversion
          ? val?.order_quantity * val.products_master.conversion_factor
          : val?.order_quantity;
        console.log(conversionValue);
        const unitPriceUom = val.unit_price_uom;
        const conversionUom = val.products_master.conversion_uom;
        const conversionFactor = val.products_master.conversion_factor;
        console.log(conversionValue, unitPriceUom, conversionUom, conversionFactor);
        let total = val.unit_price * val.order_quantity;
        console.log(total);
        let unitPrice = 0;
        unitPrice =
          unitPriceUom === conversionUom
            ? val.price_after_tax
            : conversionFactor !== 0
              ? val.price_after_tax / conversionFactor
              : val.price_after_tax
        finalTotal = unitPrice * conversionValue;
        console.log(finalTotal);
        
        total = finalTotal;
        subtotal = subtotal + total;
        console.log(subtotal);
        
        let product = {
          product: { ...val },
          conversionValue: conversionValue,
          inputValue: val?.order_quantity,
          key: val.products_master.id,
          lessCWT: val.less_cwt,
          noOfTrucks: val.no_of_trucks,
          price: val.unit_price,
          product_master_id: val.products_master.id,
          total: total,
          totalPrice: total,
          truckSize: val.truckSize,
          unit: val.products_master.input_uom,
          unitPrice: val.unit_price,
        };
        product.product.contract_number = resultData.contract_number;
        product.product.material_number = val?.material_code;
        product.inputValue = val?.order_quantity;
        product.noOfTrucks = val?.no_of_trucks;
        product.truckSize = val?.truck_size;
        product.product.id = val?.sap_contract_product_id;

        if (resultData.mode_of_delivery == 'rotation') {
          let updatedProduct = {
            ...product,
            start_time: val?.start_time,
            end_time: val?.end_time,
            quantity: val?.quantity,
            number_of_trips: val?.number_of_trips,
            is_preload: val?.is_preload,
            truck_or_trips: val?.truck_or_trips,
            duration: val?.duration,
            comment: val?.comment,
            trucktype: val?.truck_type,
            product_master_id: val?.products_master?.id,
          };
          return updatedProduct;
        } else {
          return product;
        }
      }
    );

    this.totalAmount = finalTotal;
    console.log(resultData, "gthjkl");

    const tempBalance =
      resultData?.business_payer?.sap_digital_order_balance - finalTotal;
    this.updateBalance = tempBalance;
    console.log(this.updateBalance);

    if (
      tempBalance > 0 ||
      this.disableBalChecking ||
      this.creditBalanceCheck ||
      !this.business?.is_price_check
    ) {
      this.addProductHandler(
        '',
        products,
        tempBalance,
        subtotal,
        resultData,
        resultDataTemp,
        isAggregate
      );
    } else {
      this.refresh = false;
    }
  }

  storeCartData(resultData) {
    if (resultData.mode_of_delivery == 'rotation') {
      this.store.dispatch(
        setrotationCart({
          data: {
            ...this.allCartData,
            payer: resultData.business_payer,
            plant: resultData.sap_plant,
            ship_tos: resultData.sap_business_site,
            inco_term: this.util.FIND_REVERSE_INCOTERM_TYPE(
              resultData.mode_of_delivery
            ),
            products: [],
            deliveryDetails: {},
            subTotal: 0,
            order_type: 'favouriteOrder',
          },
        })
      );
    } else {
      this.store.dispatch(
        setCart({
          data: {
            ...this.allCartData,
            payer: resultData.business_payer,
            plant: resultData.sap_plant,
            ship_tos: resultData?.sap_business_site,
            inco_term: this.util.FIND_REVERSE_INCOTERM_TYPE(
              resultData.mode_of_delivery
            ),
            products: [],
            deliveryDetails: {},
            subTotal: 0,
            order_type: 'favouriteOrder',
          },
        })
      );
    }
  }

  // callMethodsWithData ends here

  //addProductHandler code starts here

  addProductHandler(
    id,
    products,
    balance,
    amount,
    resultData,
    resultDataTemp,
    isAggregate
  ) {
    console.log(resultData);
    let tempCartData = _.cloneDeep(this.allCartData);
    console.log(tempCartData, 'one');
    let creditBalance = this.getCreditBalance(resultData);

    this.updateTempCartData(
      tempCartData,
      resultData,
      balance,
      amount,
      creditBalance
    );

    this.setDeliveryDetails(tempCartData, resultData);

    if (this.isSouthAfricaCheck && !isAggregate) {
      tempCartData['quantity_per_delivery'] = resultData?.qty_per_delivery;
    }

    tempCartData.products = products;
    tempCartData.palletProduct = this.isSouthAfricaCheck
      ? resultDataTemp.reorder_line_items.find(
        (val) => val.material_code == '000000000070004230'
      )
      : null;

    this.dispatchCart(tempCartData, resultData);
    this.refreshAndNavigation(resultData);
    this.loader = false;
    console.log(tempCartData, 'two');
  }

  // getCreditBalance(resultData) {
  //   return this.creditBlockCheck
  //     ? ( this.allCartData.balanceObject.hasOwnProperty('balance_extra_info')
  //           ? this.allCartData?.balanceObject.balance_extra_info.find(
  //               (val) => val.credit_control_area == resultData?.credit_control_area
  //             )?.sap_digital_order_balance
  //           : resultData.business_payer.sap_digital_order_balance)
  //     : resultData.business_payer.sap_digital_order_balance;
  // }

  getCreditBalance(resultData) {
    let creditBalance;

    if (this.creditBlockCheck) {
      if (this.allCartData.balanceObject.hasOwnProperty('balance_extra_info')) {
        const foundBalance =
          this.allCartData?.balanceObject.balance_extra_info.find(
            (val) => val.credit_control_area == resultData?.credit_control_area
          );
        creditBalance = foundBalance?.sap_digital_order_balance;
      } else {
        creditBalance = resultData?.business_payer?.sap_digital_order_balance;
      }
    } else {
      creditBalance = resultData?.business_payer?.sap_digital_order_balance;
    }

    return creditBalance;
  }

  updateTempCartData(tempCartData, resultData, balance, amount, creditBalance) {
    tempCartData.payer = resultData.business_payer;
    tempCartData.plant = resultData.sap_plant;
    tempCartData.ship_tos = resultData?.sap_business_site;
    tempCartData.inco_term = this.util.FIND_REVERSE_INCOTERM_TYPE(
      resultData.mode_of_delivery
    );
    tempCartData.enableMDD = resultData.mode_of_delivery == 'MDD';
    tempCartData.updatedBalance = balance;
    tempCartData.totalBalance = creditBalance || 0;
    tempCartData.subTotal = amount;
    tempCartData.total = amount;
  }

  setDeliveryDetails(tempCartData, resultData) {
    tempCartData.deliveryDetails.driver_name =
      this.business?.locale == 'ar-EG' ? '' : resultData?.driver_details;
    tempCartData.deliveryDetails.truck_number =
      this.business?.locale == 'ar-EG' || this.business?.locale == 'en-UG'
        ? ''
        : resultData?.truck_driver;
    tempCartData.deliveryDetails.lpos =
      this.business?.locale == 'ar-EG' || this.business?.locale == 'fr-FR'
        ? ''
        : resultData?.local_po_note;
    tempCartData.deliveryDetails.addresses =
      this.business?.locale == 'ar-EG' ||
        this.business?.locale == 'en-KE' ||
        this.business?.locale == 'fr-FR'
        ? ''
        : resultData?.delivery_address;
    tempCartData.deliveryDetails.contact_at_site =
      this.business?.locale == 'ar-EG' ? '' : resultData?.contact_at_site;
    tempCartData.deliveryDetails.special_instructions =
      this.business?.locale == 'ar-EG' || this.business?.locale == 'fr-FR'
        ? ''
        : resultData?.special_instructions;
    tempCartData.deliveryDetails.modeOfTransport =
      this.business?.locale == 'ar-EG' ? '' : resultData?.mode_of_transport;
    tempCartData.deliveryDetails.trucktype =
      this.business?.locale == 'ar-EG' ? '' : resultData?.vehicle_type;
    if (this.userData?.country?.locale !== 'en-GB') {
      const currentDate = new Date();
      let TempDate = new Date(currentDate);
      TempDate.setDate(currentDate.getDate() + 1);
      tempCartData.deliveryDetails.ScheduleDate =
        this.business?.locale == 'fr-FR' ? TempDate : new Date();
    }
    tempCartData.deliveryDetails.site = {
      contactSite: '',
    };
    if(this.business?.locale == 'en-NG' ||  this.business?.locale == 'en-KE'){
      let currentTime = moment(new Date()).format('hh:mm a')
       tempCartData.deliveryDetails.scheduleTime = currentTime
    }
  }

  dispatchCart(tempCartData, resultData) {
    if (resultData.mode_of_delivery == 'rotation') {
      this.store.dispatch(setrotationCart({ data: tempCartData }));
    } else {
      this.store.dispatch(setCart({ data: tempCartData }));
    }
  }

  refreshAndNavigation(resultData) {
    console.log(resultData);

    if (resultData.mode_of_delivery == 'rotation') {
      this.router.navigateByUrl('create-orders/rotation-cement');
    } else if (resultData.mode_of_delivery != 'rotation') {
      console.log("check", this.allCartData);
      if (this.userData?.country?.locale == 'en-GR' && this.allCartData?.isOrderAggregate) {
        this.store.dispatch(
          setCart({
            data: {
              ...this.allCartData,
              isAggregate: true,
            },
          })
        );
        this.router.navigateByUrl('create-orders/aggregate');
      } else {
        this.store.dispatch(
          setCart({
            data: {
              ...this.allCartData,
              isAggregate: false,
              isAggregateTab: this.allCartData?.isOrderAggregate ? true : false,
              isAsphaltTab: this.allCartData?.isOrderAsphalt ? true : false
            },
          })
        );
        console.log(location.pathname, this.isAggregate);
        if (location.pathname !== '/dashboard') {
          if (this.allCartData?.isOrderAggregate) {
            this.router.navigateByUrl('create-orders/aggregate');
          } else if (this.allCartData?.isOrderAsphalt) {
            this.router.navigateByUrl('create-orders/asphalt');
          } else {
            this.router.navigateByUrl('create-orders/cement');
          }
        } else {
          if (this.isAggregate) {
            this.router.navigateByUrl('create-orders/aggregate');
          } else if (this.isAsphalt) {
            this.router.navigateByUrl('create-orders/asphalt');
          } else {
            this.router.navigateByUrl('create-orders/cement');
          }
        }
      }
    }
  }

  //addProductHandler code ends here

  getTncprivatePolicy() {
    return this.http.get<any>(
      `${this.localData?.loginDetails?.url}/users/${this.localData?.otpVerifiedDetails?.id}/term_and_conditions/${this.localData?.localLanguage?.id}`
    );
  }

  acceptPrivatePolicy() {
    return this.http.patch<any>(
      `${this.localData?.loginDetails?.url}/users/${this.localData?.otpVerifiedDetails?.id}/accept_tnc`,
      {}
    );
  }

  rejectPrivatePolicy() {
    return this.http.patch<any>(
      `${this.localData?.loginDetails?.url}/users/${this.localData?.otpVerifiedDetails?.id}/reject_tnc`,
      {}
    );
  }
  exportAsCSV(fromDate: any, toDate: any, statusOrder: any, order_number: any, order_ids: any) {
    let type = 'cement';
    return this.http.get(
      `${this.localData?.loginDetails?.url}/businesses/${this.localData?.userDetails?.business?.id}/export_orders?fromDate=${fromDate}&toDate=${toDate}&type=${type}&orderStatus=${statusOrder}&order_number=${order_number}&order_ids=${order_ids}`
    );
  }

  getRolesInfo() {
    return this.http.get(
      `${this.localData?.allApiLinks?.self?.href}/businesses/roles`
    );
  }
  // <---------------- Loyalty_points starts -------------->
  getLoyaltyPoints() {
    return this.http.get<any>(
      `${this.localData?.allApiLinks?.self?.href}/businesses/${this.localData?.userDetails?.business?.id}/get_loyalty_points`
    );
  }
  getUserLoyaltyPoints(page: any) {

    return this.http.get<any>(
      `${this.localData?.allApiLinks?.self?.href}/businesses/users/${this.localData?.userDetails?.id}/user_loyalty_points?page=${page}`
    );
  }
  getRewardsLoyaltyPoints() {
    return this.http.get<any>(
      `${this.localData?.allApiLinks?.self?.href}/businesses/users/${this.localData?.userDetails?.id}/loyalty_rewards_list`
    );
  }
  // <---------------- Loyalty_points  ends-------------->
  downloadTransaction(data: any) {
    let queryParams = new HttpParams();
    if (this.userData?.country?.locale !== 'en-GB') {
      queryParams = queryParams.append(
        'delivery_note_number',
        data?.lsd_order_no
      );
    } else {
      queryParams = queryParams.append(
        'delivery_note_number',
        data?.logon_order_no
      );
    }
    return this.http.get(
      `${this.deliverpdfUrl}/businesses/${this.localData?.userDetails?.business?.id}/get_delivery_pdf`,
      { params: queryParams, responseType: 'arraybuffer' }
    );
  }
  downloadBulkTransaction(orderId: any) {
    let queryParams = new HttpParams();
    queryParams = queryParams.append(
      'order_number',
      orderId
    );
    return this.http.get<any>(
      `${this.localData?.allApiLinks?.self?.href}/businesses/${this.localData?.userDetails?.business?.id}/get_bulk_delivery_pdfs`,
      { params: queryParams, responseType: 'arraybuffer' as 'json' }
    );
  }
  // <---------------- Apply_Coupon starts -------------->
  couponDetails() {
    return this.http.get<any>(
      `${this.localData?.allApiLinks?.self?.href}/businesses/${this.localData?.userDetails?.business?.id}/fetch_voucher_assigend_list`
    );
  }
  removeKey(obj: any, key: string) {
    const { [key]: deletedKey, ...rest } = obj;
    return rest;
  }
  removeCoupon() {
    let updatedCartData = {
      ...this.allCartData,
      discount_Details: {},
      couponValue: false,
    };
    updatedCartData = this.removeKey(updatedCartData, 'discount_Details')
    updatedCartData = this.removeKey(updatedCartData, 'couponValue')
    this.store.dispatch(
      setCart({
        data: updatedCartData,
      })
    );
  }

  searchCoupon(data) {
    return this.http.get<any>(
      `${this.localData?.allApiLinks?.self?.href}/businesses/${this.localData?.userDetails?.business?.id}/discount_coupon_check?coupon=${data}`
    );
  }
  // <---------------- Apply_Coupon Ends -------------->
}
